import { Outlet } from "react-router-dom";

const AuthLayOut: React.FC = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default AuthLayOut;
